export class AbstractConnectionStrategy {
  constructor(options) {
    this.handshakeResult = null;
    this.options = options;
  }
}